import { render, staticRenderFns } from "./BuildingLocationIcon.vue?vue&type=template&id=0f388529&"
import script from "./BuildingLocationIcon.vue?vue&type=script&lang=ts&"
export * from "./BuildingLocationIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports